/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */

/**
 * Type of the contact, e.g. email or phone
 */
export type UserContactApiResourceType = typeof UserContactApiResourceType[keyof typeof UserContactApiResourceType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserContactApiResourceType = {
  email: 'email',
  phone: 'phone',
} as const;
